import React, { Component } from 'react';

import LoadingAnimation from '@/shared/components/LoadingAnimation';

export default class PhotoViewer extends Component {
  render() {
    const { filePath } = this.props;
    if (!filePath) {
      return <LoadingAnimation />;
    }

    return <img src={filePath} crossOrigin="anonymous" className="photo" />;
  }
}
